import { render, staticRenderFns } from "./ViewChart.vue?vue&type=template&id=94702674&scoped=true&"
import script from "./ViewChart.vue?vue&type=script&lang=js&"
export * from "./ViewChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94702674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94702674')) {
      api.createRecord('94702674', component.options)
    } else {
      api.reload('94702674', component.options)
    }
    module.hot.accept("./ViewChart.vue?vue&type=template&id=94702674&scoped=true&", function () {
      api.rerender('94702674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Includes/Charts/VideoStats/ViewChart.vue"
export default component.exports